//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength, maxLength, helpers } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import errorTags from "@/ErrorTags";
import jsonToExcel from "@/components/jsonToExcel.vue";
import moment from 'moment'
import { date } from 'quasar'
import { exportFile } from 'quasar'

const containDate = helpers.regex("containAlphaNum", /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);

function wrapCsvValue (val, formatFn) {
  let formatted = formatFn !== void 0
    ? formatFn(val)
    : val

  formatted = formatted === void 0 || formatted === null
    ? ''
    : String(formatted)

  formatted = formatted.split('"').join('""')

  /**
   * Excel accepts \n and \r in strings, but some other CSV parsers do not
   * Uncomment the next two lines to escape new lines
   */
  // .split('\n').join('\\n')
  // .split('\r').join('\\r')

  // return `"${formatted}"`
  return `"'${formatted}'"`

}

export default {
  components: {
    ValidateResult,
    jsonToExcel
  },
  data () {
    return {
      dpMatchDate: new Date().toISOString().slice(0,10),
      ddlCompanyList: null,
      // txtFilterDataTableList: "",

      dtMatchDate: null,
      strCompanyList: null,

      strColor: "orange",
      strTitle: "List",
      strTableSeparators: 'cell',
      blnDense: true,
      blnDenseOptions: true,
      blnLoading: false,
      blnMatchDateAutoFocus: true,
      blnButtonDisable: true,

      strMaskTextBox:'####-##-##',
      strMaskDatePicker: "YYYY-MM-DD",

      aryData: [],
      aryAPIData: [],
      aryVisibleColumns: [ 'Company', 'Type', 'Number', 'Bet (MYR)', 'Date' ],
      aryColumns: [
        { name: 'Company', label: 'Company Name', field: 'Company', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'Type', label: 'Type', field: 'Type', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'Number', label: 'Number', field: 'Number', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'Bet (MYR)', label: 'Bet Amount(MYR)', field: 'Bet (MYR)', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'Date', label: 'Match Date', field: 'Date', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
      ],
      strRowKey: "Number",

      dicPagination: {
        sortBy: 'Number',
        descending: false,
        page: 1,
        rowsPerPage: config.aryPageSizeList[0],
        rowsNumber: 0
      },

      aryOptionsPageSizeList: config.aryPageSizeList,
      aryOptionsCompanyList: config.aryCompanyList,

      blnShowMessage: false,
      strBannerClass: "",
      strBannerMessage: "",

      jsonResponse: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    dpMatchDate: {
      required,
      containDate,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    ddlCompanyList: {
      required
    }
  },
  methods: {
    fcValidationDate (strValue) {
      return date.isValid(strValue) || "Invalid Date.";
    },
    fcMatchDateAutoClose () {
      this.$refs.puDatePicker.hide();
    },
    fcFilterCompanyList (strValue, update, abort) {
      if (strValue === "") {
        update(() => {
          this.aryOptionsCompanyList = config.aryCompanyList
        });
        return;
      }

      if (strValue.length < 1) {
        abort();
        return;
      }

      update(() => {
        const strSearch = strValue.toLowerCase();
        this.aryOptionsCompanyList = config.aryCompanyList.filter(list => list.label.toLowerCase().indexOf(strSearch) > -1);
      })
    },
    fcClearCompanyList () {
      this.ddlCompanyList = null;
      // this.txtFilterDataTableList = "";

      this.blnButtonDisable = true;
      this.blnShowMessage = false;

      this.aryData = [];
      this.dicPagination.page = 1;
    },
    fcSearch () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
      this.aryData = [];
      this.dicPagination.page = 1;

        this.fcGetDataList();
      }
    },
    fcGetDataList () {
      let apiURL = config.betList_Company_Url();

      var jsonRequest = {
        session_token: this.$store.getters.sessionToken,
        user_id: this.$store.getters.username,
        match_date: this.dpMatchDate,
        comp_id: this.ddlCompanyList.value,
      };

      // console.log(jsonRequest);

      this.blnLoading = true;
      this.jsonResponse.success = true;

      this.$http.post(apiURL, jsonRequest).then(
        function(apiResponse) {
          // Json Response Success
          // console.log(apiResponse);
          this.blnLoading = false;

          try {
            if (apiResponse) {
              if (typeof apiResponse.data.status == "string") {
                this.jsonResponse.success = apiResponse.data.status == "1";
              } else {
                this.jsonResponse.success = apiResponse.data.status == 1;
              }

              this.jsonResponse.status = apiResponse.data.statusdesc;

              if (this.jsonResponse.success == true) {
                this.aryAPIData = apiResponse.data.value;
                if (this.aryAPIData.length > 0) {
                  this.blnButtonDisable = false;
                  this.aryData = this.aryAPIData;
                } else {
                  this.blnButtonDisable = true;
                  this.$helpers.showDialog(this.$t("ui.combine.search_bet_list"), this.$t("message.bet_list_no_result", { fname: this.dpMatchDate, fname2: this.ddlCompanyList.label }), "info");
                }

                // this.strTitle = this.ddlCompanyList.label + " " + this.fcFormatDateTime(this.dpMatchDate) + " List";
                this.strTitle = this.ddlCompanyList.label + " " + this.dpMatchDate + " List";
                this.dtMatchDate = this.dpMatchDate;
                this.strCompanyList = this.ddlCompanyList
                this.dicPagination.rowsNumber = apiResponse.data.value[0]["totalrows"];
              } else {
                this.blnShowMessage = true;
                this.strBannerClass = "cssBannerError";
                this.strBannerMessage = this.jsonResponse.status;

                // if (this.jsonResponse.status == "invalidToken"){
                //   this.$helpers.handleFeedback(this.jsonResponse.status);
                // }

                let blnCommonResult = this.$helpers.handleFeedback(this.jsonResponse.status);
              }
            }
          } catch (error) {
            this.jsonResponse.success = false;
            this.jsonResponse.status = errorTags.request.failed;
          }
        },
        function(apiResponse) {
          // Json Response Error
          this.blnLoading = false;
          this.jsonResponse.success = false;
          this.jsonResponse.status = errorTags.request.failed;
        }
      )
    },
    fcRequest (props) {
      const { page, rowsPerPage, rowsNumber } = props.pagination;

      this.blnLoading = true;

      this.dicPagination.page = page;

      if (rowsPerPage === 0) {
        this.dicPagination.rowsPerPage = rowsNumber;
      }else{
        this.dicPagination.rowsPerPage = rowsPerPage;
      }

      this.blnLoading = false;

      this.fcGetDataList();
    },
    fcFormatCompanyName (strValue) {
      // if (strValue == undefined){
      //   return;
      // }

      return config.aryCompanyList.find((tblInfo) => tblInfo.label.toLowerCase() === strValue.toLowerCase()).label;
      // return config.aryCompanyList.find((tblInfo) => tblInfo.value == strValue) != undefined ? config.aryCompanyList.find((tblInfo) => tblInfo.value == strValue).label : "";
    },
    fcFormatDateTime (strValue) {
      // YYYY-MM-DD hh:mm:ss.SSS a
      return moment(new Date(strValue)).format('YYYY-MM-DD hh:mm:ss a');
    },
    fcExport () {
      // Naive Encoding(Original) To CSV Format(Excel)
      const strContent = [ this.aryColumns.map(col => wrapCsvValue(col.label)) ].concat(
        this.aryData.map(row => this.aryColumns.map(col => wrapCsvValue(
          typeof col.field === 'function'
            ? col.field(row)
            : row[col.field === void 0 ? col.name : col.field],
          col.format
        )).join(','))
      ).join('\r\n')

      const blnStatus = exportFile(
        'Bet_List_Export_' + this.dpMatchDate + '_' + this.ddlCompanyList.label + '.csv',
        strContent,
        'text/csv'
      )

      if (blnStatus !== true) {
        // this.$q.notify({
        //   message: 'Browser denied file download...',
        //   color: 'negative',
        //   icon: 'warning'
        // })

        this.$helpers.showDialog(this.$t("ui.export_excel"), this.$t("message.export_excel_no_result"), "warning");
      }
    },
  }
};
